import { render, staticRenderFns } from "./V2Matches.vue?vue&type=template&id=ff0e1c60&scoped=true&"
import script from "./V2Matches.vue?vue&type=script&lang=js&"
export * from "./V2Matches.vue?vue&type=script&lang=js&"
import style0 from "./V2Matches.vue?vue&type=style&index=0&id=ff0e1c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0e1c60",
  null
  
)

export default component.exports